<template>
    <v-row>
        <v-col cols="12" md="5" class="mb-34 mb-md-0">
            <v-img :src="'/images/sub/product/'+file+'/main_img.jpg'" max-width="486" class="w-100 main-img mx-auto"></v-img>
        </v-col>
        <v-col cols="12" md="7">
            <div class="pl-md-20 pl-lg-60 pt-md-30 pt-xl-90 word-keep-all">
                <div class="tit-wrap">
                    <h3 class="tit tit--lg" data-aos="fade-up">{{tit}}</h3>
                </div>
                <div class="prduct-detail mb-30 mb-lg-60 pa-20 pa-md-30 py-lg-36 px-md-54 px-lg-84">
                    <p class=" page-text">
                        <slot/>
                    </p>
                </div>
                <v-row class="row--small row-cols-5">
                    <v-col data-aos="fade-right">
                        <v-img :src="'/images/sub/product/'+file+'/1.jpg'" class="w-100"></v-img>
                    </v-col>
                    <v-col data-aos="fade-right" data-aos-delay="100">
                        <v-img :src="'/images/sub/product/'+file+'/2.jpg'" class="w-100"></v-img>
                    </v-col>
                    <v-col data-aos="fade-right" data-aos-delay="200">
                        <v-img :src="'/images/sub/product/'+file+'/3.jpg'" class="w-100"></v-img>
                    </v-col>
                    <v-col data-aos="fade-right" data-aos-delay="300">
                        <v-img :src="'/images/sub/product/'+file+'/4.jpg'" class="w-100"></v-img>
                    </v-col>
                    <v-col data-aos="fade-right" data-aos-delay="400">
                        <v-img :src="'/images/sub/product/'+file+'/5.jpg'" class="w-100"></v-img>
                    </v-col>
                </v-row>
            </div>
        </v-col>
    </v-row>
</template>

<script>
export default{
    props: {
        tit: { type: String, default: "" },
        file: { type: String, default: "" },
    },
    components: {
    },
    data: () => {
        return {
        }
    },
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		init : function() {
		}
	},
}
</script>

<style scoped>
.main-img{
    box-shadow: 12px 12px 16px rgba(12, 34, 53, 0.2);
}

.prduct-detail{
    background-color: var(--v-secondary-base); 
    border-right: 2px solid var(--v-primary-base); 
}

.prduct-detail .page-text{
    color: #d1d8dd;  
}

@media (min-width:576px){
}
@media (min-width:768px){
    .prduct-detail{
        position: relative;
        width: calc(100% + 44px);
        left: -44px;
    }
}
@media (min-width:1024px){
    .main-img{
        box-shadow: 20px 20px 25px rgba(12, 34, 53, 0.2);
    }

    .prduct-detail{
        width: calc(100% + 84px);
        left: -84px;
        border-right: 4px solid var(--v-primary-base); 
    }
}
@media (min-width:1200px){
}

</style>